import { Navigate } from 'react-router-dom';

export const HomePage = (): JSX.Element => {
  return (
    <div>
      <Navigate to="login" replace={true} />
    </div>
  );
};
